import { FilterMultiSelect } from "@/components/common/FilterMultiSelect";
import { useStaff } from "@/components/pages/staff/hooks/useStaff";
import { useHotel } from "@/hooks/useHotel";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export interface StaffFilterProps {
  ids: string[];
  onChange: (ids: string[]) => void;
  placeholder?: string;
}

const StaffFilter: React.FC<StaffFilterProps> = ({
  ids,
  onChange,
  placeholder,
}) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<string[]>(ids || []);

  const { hotelId } = useHotel();
  const { data: staffData } = useStaff({ hotelId });

  const handleChange = (ids: string[]) => {
    setSelected(ids);
    onChange(ids);
  };

  return (
    <FilterMultiSelect
      className="w-[200px] justify-between"
      options={
        staffData?.users
          ? staffData.users.map((staff) => ({
              value: staff.id,
              label: `${staff.firstName} ${staff.lastName}`,
            }))
          : []
      }
      placeholder={
        placeholder ?? t("feedbacks.filters.staff", "Filter feedbacks by staff")
      }
      value={selected}
      onValueChange={handleChange}
    />
  );
};

export default StaffFilter;
